<h1 mat-dialog-title class="w-100"><i class="fa-solid fa-user"></i> Dodaj pracownika</h1>
<mat-dialog-content class="mat-typography">
	<mat-form-field class="w-100">
		<input matInput type="text" placeholder="Imię" [(ngModel)]="organizationWorkersData.user.first_name" />
	</mat-form-field>
	<mat-form-field class="w-100">
		<input matInput type="text" placeholder="Nazwisko" [(ngModel)]="organizationWorkersData.user.last_name"
	/></mat-form-field>
	<mat-form-field class="w-100">
		<input matInput type="email" placeholder="Email" [(ngModel)]="organizationWorkersData.user.email" />
	</mat-form-field>
	<mat-form-field class="w-100">
		<mat-select placeholder="Stanowisko" [(ngModel)]="organizationWorkersData.role">
			<mat-option [value]="role.id" *ngFor="let role of service.enterpriseData.organizationRoles">{{
				role.name
			}}</mat-option>
		</mat-select>
	</mat-form-field>
	<mat-form-field class="w-100">
		<mat-select placeholder="Dział" [(ngModel)]="organizationWorkersData.department">
			<mat-option [value]="item.id" *ngFor="let item of service.enterpriseData.departmentsForUsers">{{
				getDepartment(item.kind)
			}}</mat-option>
		</mat-select>
	</mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
	<button mat-raised-button color="primary" (click)="addOrganizationWorker()" cdkFocusInitial>Dodaj adres</button>
</mat-dialog-actions>
